/* Small native interactions. Facts, prices and fallbacks are server rendered. */
(() => {
  'use strict';
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  function bindSelection(scene, kind) {
    const buttons = [...scene.querySelectorAll(`[data-${kind}-select]`)];
    const panels = [...scene.querySelectorAll(`[data-${kind}-panel]`)];
    if (!buttons.length || buttons.length !== panels.length) return;
    function select(value, initiated = false) {
      buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset[`${kind}Select`] === value)));
      panels.forEach(panel => { panel.hidden = panel.dataset[`${kind}Panel`] !== value; });
      scene.dataset.selected = value;
      scene.querySelectorAll(`[data-${kind}-marker]`).forEach(marker => marker.classList.toggle('is-selected', marker.dataset[`${kind}Marker`] === value));
      if (kind === 'pack' && initiated && scene.dataset.open !== 'true') scene.querySelector('.j-parcel-scene__footer button:not([hidden])')?.click();
    }
    buttons.forEach(button => button.addEventListener('click', () => select(button.dataset[`${kind}Select`], true)));
    select(buttons[0].dataset[`${kind}Select`]);
    scene.dataset.visualReady = 'true';
    scene.querySelector(`[class*="${kind === 'meal' ? 'j-meal-showcase' : kind === 'cut' ? 'j-cut-explorer' : 'j-pack-explorer'}__controls"]`).hidden = false;
  }
  function placeCutMarkers(scene) {
    const img = scene.parentElement.querySelector(':scope > img');
    const map = scene.querySelector('.j-cut-explorer__map');
    if (!img || !map) return;
    const points = { eye: [.593, .468], marbling: [.769, .589] };
    function place() {
      const box = img.getBoundingClientRect();
      if (!img.naturalWidth || !box.width || !box.height) return;
      const scale = Math.max(box.width / img.naturalWidth, box.height / img.naturalHeight);
      const xOffset = (box.width - img.naturalWidth * scale) / 2;
      const yOffset = (box.height - img.naturalHeight * scale) / 2;
      map.setAttribute('viewBox', `0 0 ${box.width} ${box.height}`);
      map.style.height = `${box.height}px`;
      Object.entries(points).forEach(([name, point]) => {
        const group = scene.querySelector(`[data-cut-marker="${name}"]`);
        const x = xOffset + point[0] * img.naturalWidth * scale;
        const y = yOffset + point[1] * img.naturalHeight * scale;
        group.setAttribute('transform', `translate(${x} ${y})`);
        group.querySelectorAll('circle').forEach(circle => { circle.setAttribute('cx', '0'); circle.setAttribute('cy', '0'); });
      });
    }
    img.addEventListener('load', place);
    scene.addEventListener('toggle', place);
    if ('ResizeObserver' in window) new ResizeObserver(place).observe(img);
    else window.addEventListener('resize', place, { passive: true });
    place();
  }
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      if (!reduced.matches) entry.target.classList.add('j-evidence-arrived');
      observer.unobserve(entry.target);
    });
  }, { threshold: .12 }) : null;
  function init(root = document) {
    [['meal', '[data-meal-showcase]'], ['cut', '[data-cut-explorer]'], ['pack', '[data-pack-explorer]']].forEach(([kind, selector]) => {
      root.querySelectorAll(`${selector}:not([data-visual-ready])`).forEach(scene => {
        bindSelection(scene, kind);
        if (kind === 'cut') placeCutMarkers(scene);
        if (kind === 'meal') observer?.observe(scene);
      });
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  reduced.addEventListener('change', event => {
    if (event.matches) document.querySelectorAll('.j-evidence-arrived').forEach(el => el.classList.remove('j-evidence-arrived'));
  });
})();
